import * as React from "react";
import { v4 } from "uuid";

import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Badge from '@material-ui/core/Badge';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';

import "./../../resources/forest.jpg";

import { ThemeProvider } from '@material-ui/core/styles';

import { createMuiTheme } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import {ExerciseTask, TaskOption, Exercise} from '../server/ExamServer'
import ExamTask from "./ExamTask";
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';

const theme = createMuiTheme({
    palette: {
        // primary: {
        //     main: '#44423e'
        // },
        // secondary: {
        //     main: '#FDC400',
        //     contrastText: '#fff'
        // }
    }

});

export interface ExamExerciseResultListItemProps {
    tasks:Array<ExerciseTask>
    name: string
    overall: boolean
}

export interface ExamExerciseResultListItemState {

}


class ExamExerciseResultListItem extends React.Component<ExamExerciseResultListItemProps, ExamExerciseResultListItemState> {


    constructor(props: ExamExerciseResultListItemProps) {
        super(props);
    }

     
    getTiername = (successful:number):string => {
        if(successful < 16){
            return "Starter"
        }
        else if(successful < 36){
            return "Elementary"
        }
        else if(successful < 56){
            return "Pre-intermediate"
        }
        else if(successful < 76){
            return "Intermediate"
        }
        else if(successful < 96){
            return "Upper Intermediate"
        }
        else {
            return "Advanced"
        }
    }

    render() {

        const {tasks, name} = this.props

        const successful:number = tasks.filter(task=>{
            return task.options.filter(option=>{
                return option.checked === true && option.expected === true
            }).length === 1
        }).length
        
        return (
            <div style={{margin:theme.spacing(3), marginTop:theme.spacing(5)}}>

                {this.props.overall?(     
                    <Typography variant={"h6"} color="secondary" component="h5">
                        {this.getTiername(successful)}
                    </Typography>
                ):(
                    <Typography variant={"subtitle2"} color="initial" component="h5">
                        {name}
                    </Typography>
                )}


                <Typography variant="subtitle1" color="textPrimary" component="h5">
                    {successful}/{tasks.length}
                </Typography>
                
                <LinearProgress variant="determinate" value={100*successful/tasks.length} color={this.props.overall?"secondary":"primary"}/>


            </div>

        );
    }
}

export default ExamExerciseResultListItem;
